import { PrerenderRequest } from 'corporate-types';
import ProductPresentationComponent from '../../../components/product-presentation/productPresentation';
import SectionHeaderCms from '../../../components/section-header-cms/SectionHeaderCms';
import { Product } from '../../../models/auto-generated-strapi-types/types/Product';
import { PresentationConfig } from '../../../models/auto-generated-strapi-types/types/components/PresentationConfig';
import { SectionHeader } from '../../../models/auto-generated-strapi-types/types/components/SectionHeader';
import {
  InnerWrapper,
  OuterWrapper,
  PresentationTop,
} from './productPresentation.style';

interface ProductPresentation {
  id: number;
  products: Product[];
  backgroundColor?: string;
  presentationConfigs: PresentationConfig;
  sectionHeader?: SectionHeader;
}

const ProductPresentationSection: React.FC<
  {
    data: ProductPresentation;
    isPrerenderRequest: boolean;
  } & PrerenderRequest
> = ({
  data,
  isPrerenderRequest,
}: {
  data: ProductPresentation;
  isPrerenderRequest: boolean;
} & PrerenderRequest) => {
  return (
    <OuterWrapper>
      <InnerWrapper>
        {data?.sectionHeader?.title && data?.sectionHeader?.mainTitle && (
          <PresentationTop>
            <SectionHeaderCms
              id={data?.id}
              topIcon={data?.sectionHeader?.topIcon}
              title={data?.sectionHeader?.title}
              mainTitle={data?.sectionHeader?.mainTitle}
              description={data?.sectionHeader?.description}
              personalization={data?.sectionHeader?.personalization}
              isPrerenderRequest={isPrerenderRequest}
            />
          </PresentationTop>
        )}
        <ProductPresentationComponent
          products={data?.products}
          presentationConfigs={data?.presentationConfigs}
        />
      </InnerWrapper>
    </OuterWrapper>
  );
};

export default ProductPresentationSection;
